import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";

import { LoadingService } from "../loading/loading.service";

export const SKIP_LOADING_HEADER = "X-SAT-Skip-Loading";

@Injectable()
export class LoadingInterceptorService implements HttpInterceptor {
  private readonly loadingScreenService = inject(LoadingService);

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (request.headers.has(SKIP_LOADING_HEADER)) {
      return next.handle(
        request.clone({
          headers: request.headers.delete(SKIP_LOADING_HEADER),
        }),
      );
    }

    this.loadingScreenService.startLoading();

    return next.handle(request).pipe(
      finalize(() => {
        this.loadingScreenService.stopLoading();
      }),
    );
  }
}
